import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";

// Mesma lógica de ver/baixar documentos da ListUsers clássica
const resolveDocumentUrl = (doc) =>
  /^https?:\/\//i.test(doc) ? doc : cloudinaryInstance.image(doc).toURL();

export const getUserDocuments = (user) =>
  [user?.documentURL1, user?.documentURL2]
    .map((url, index) => ({ url, number: index + 1 }))
    .filter((doc) => !!doc.url);

export const openDocument = (doc) => {
  if (!doc) return;
  const link = document.createElement("a");
  link.href = resolveDocumentUrl(doc);
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  link.click();
};

export const downloadDocument = async (doc) => {
  try {
    const response = await fetch(resolveDocumentUrl(doc), { mode: "cors" });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = doc.split("/").pop() || "document.pdf";
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao baixar documento:", error);
  }
};
